import { __assign } from "tslib";
import { connectMediaStore, useMMDispatchActions, useMMSelector, } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getGallectionStreamId } from '../helpers';
import { getCurrentMediaSource, getTopLevelGallections } from '../selectors';
import { fetchMoreGallections } from '../actions';
import { SCRAPS_FOLDER_ID } from '@wix/da-url';
var mapStateToProps = function (state) {
    var mediaSource = getCurrentMediaSource(state);
    var streamId = getGallectionStreamId(mediaSource);
    var putScrapsFolderLast = function (a, b) {
        return b.folderId === SCRAPS_FOLDER_ID ? -1 : 0;
    };
    var gallections = getTopLevelGallections(state).sort(putScrapsFolderLast);
    return {
        gallections: gallections,
        hasMoreGallections: selectors.hasMore(state, streamId),
        isFetchingGallections: selectors.isFetching(state, streamId),
        isGallectionStreamInitialized: selectors.isInitialized(state, streamId),
    };
};
var mapDispatchToProps = {
    fetchMoreGallections: fetchMoreGallections,
};
export var useGallections = function () { return (__assign(__assign({}, useMMSelector(mapStateToProps)), useMMDispatchActions({ fetchMoreGallections: fetchMoreGallections }))); };
export default connectMediaStore(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=withGallections.js.map